import { UserSuggestResponse } from '../AbstractComboBox/api/UserSuggestResponse';
import { TopUserResult } from '../AbstractComboBox/types/SuggestResultTypes';
import { Section } from '../AbstractComboBox/types/Section';

export default function getUserTopResults(response: UserSuggestResponse): Section<TopUserResult>[] {
  return [
    {
      key: 'user',
      results: response.user.topResults.map(TopUserResult),
    },
  ];
}
